import generatedDemo from "./demoData.generated.json";

export const DEMO_REPLAY = generatedDemo;
